import type { ReviewItemStatus } from "../types/reviewItem";

const CONFIG: Record<ReviewItemStatus, { label: string; className: string }> = {
  PENDIENTE_CONTADURIA: { label: "Pendiente Contaduría", className: "badge-pend" },
  PENDIENTE_COMPRADOR: { label: "Esperando Aprobador", className: "badge-wait" },
  APROBADO_PENDIENTE_POSTEO: { label: "En cola · posteo a SAP", className: "badge-wait" },
  PROCESANDO: { label: "Procesando", className: "badge-wait" },
  EN_SAP: { label: "En SAP", className: "badge-auth" },
  ERROR_POSTEO: { label: "Error de posteo", className: "badge-rej" },
  RECHAZADA: { label: "Rechazada", className: "badge-rej" },
};

export function StatusBadge({ status }: { status: ReviewItemStatus }) {
  const cfg = CONFIG[status] ?? { label: status, className: "badge-pend" };
  return (
    <span className={`badge ${cfg.className}`}>
      <span className="badge-dot" />
      {cfg.label}
    </span>
  );
}
